var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip"},[_c('img',{attrs:{"src":_vm.buttonImage(),"alt":_vm.alt},on:{"blur":function($event){_vm.hidden = false}}}),(!_vm.hidden)?_c('span',{staticClass:"tooltiptext",attrs:{"id":_vm.name},on:{"click":_vm.toggle}},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }